// src/components/Header.js
import React, { useState } from 'react';
import { slide as Menu } from 'react-burger-menu';
import { NavLink, Link } from 'react-router-dom'; 
import '../styles/Header.css';

const CloseIcon = () => (
  <div
    style={{
      width: '60px',
      height: '60px',
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      backgroundColor: 'transparent'
    }}
  >
    <div className="close-icon-line first-line"></div>
    <div className="close-icon-line second-line"></div>
  </div>
);

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const handleStateChange = (state) => setMenuOpen(state.isOpen);
  const closeMenu = () => setMenuOpen(false);

  const menuStyles = {
    bmMenuWrap : {
      position: 'fixed',
      height  : '100%',
      width   : '100vw',
      top     : 0,
      left    : 0,
      transform: 'none',
    },
    bmMenu: {
      background: '#930707',
      padding   : '2rem 1.25rem',   // ← боковые поля чуть меньше
      fontSize  : '1.15em',
      opacity   : menuOpen ? 1 : 0,
      zIndex    : 1000,
    },
    bmOverlay: {
      background: 'transparent',
    },
    bmCrossButton: {
      position: 'fixed',
      left: '1.3rem',
      top: '3.7rem',
      width: '3rem',
      height: '3rem',
      zIndex: 3300,
    },
    bmCross: {
      display: 'none',
    },
  };

  return (
    <header className="site-header">
      <Menu 
        isOpen={menuOpen} 
        onStateChange={handleStateChange}
        styles={menuStyles}
        customCrossIcon={<CloseIcon />}
      >
        <div className="menu-overlay">
          <div className="menu-columns">
            {/* Первая колонка */}
            <div className="menu-column column-1">
               <p className="menu-heading">EXPLORE</p>
             <div className="menu-group explore-group">
                <NavLink to="/home" onClick={closeMenu} className={({ isActive }) =>  isActive ? "menu-item active" : "menu-item"}>HOME</NavLink>
                {/* <NavLink to="/fashion"      onClick={closeMenu} className={({ isActive }) => isActive ? "menu-item active" : "menu-item"}>FASHION</NavLink>
                <NavLink to="/music"        onClick={closeMenu} className={({ isActive }) => isActive ? "menu-item active" : "menu-item"}>MUSIC</NavLink> */}
              </div> 
              <p className="menu-heading">ABOUT</p>
              <div className="menu-group about-group">
                <NavLink to="/about"         onClick={closeMenu} className={({ isActive }) => isActive ? "menu-item active" : "menu-item"}>ABOUT RIFF</NavLink>
                {/* <div className="menu-group gallery-group">
                 <NavLink to="/gallery"       onClick={closeMenu} className={({ isActive }) => isActive ? "menu-item active" : "menu-item"}>GALLERY</NavLink> 
              </div>
                
                <NavLink to="/writeforus"    onClick={closeMenu} className={({ isActive }) => isActive ? "menu-item active" : "menu-item"}>CONTACT US</NavLink>*/}
              </div> 
            </div>

            {/* Вторая колонка */}
            <div className="menu-column column-2">
              {/* <div className="menu-group interviews-group">
                <NavLink to="/interviews"    onClick={closeMenu} className={({ isActive }) => isActive ? "menu-item active" : "menu-item"}>INTERVIEWS</NavLink>
                <NavLink to="/artdesign"     onClick={closeMenu} className={({ isActive }) => isActive ? "menu-item active" : "menu-item"}>ART &amp; DESIGN</NavLink>
              </div> */}
              <p className="menu-heading">SOCIAL MEDIA</p>
              <div className="menu-group social-group">
                <a href="https://www.instagram.com/theriffmag?igsh=NWpoNGQ1em5zYmFm"
                   target="_blank"
                   rel="noopener noreferrer"
                   onClick={closeMenu}
                   className="menu-item"
                >
                  INSTAGRAM
                </a>
              </div>
            </div>

            {/* Третья колонка */}
            <div className="menu-column column-3">
              {/* <div className="menu-group gallery-group">
                <NavLink to="/gallery"       onClick={closeMenu} className={({ isActive }) => isActive ? "menu-item active" : "menu-item"}>GALLERY</NavLink>
              </div> */}
              <p className="menu-heading">SPECIAL</p>
              <div className="menu-group ai-group">
                <NavLink to="/riffai"        onClick={closeMenu} className={({ isActive }) => isActive ? "menu-item active" : "menu-item"}>RIFF.AI</NavLink>
              </div>
            </div>
          </div>
          <div className="menu-title">RIFF MAGAZINE</div>
        </div>
      </Menu>

      <div className="header-content">
        {/* Здесь меняем текст на логотип */}
        <div className="site-title">
          <Link to="/home" onClick={closeMenu}>
            <img
              src="/assets/image.png"
              alt="RIFF Magazine Logo"
              className="header-logo"
            />
          </Link>
        </div>
        <p className="header-subtitle">WHERE STYLE AND SOUND INTERSECT</p>
      </div>
    </header>
  );
};

export default Header;
